import { circleGeoJSON, validCenter } from './plazaGeometry';

// Mirrors mobile release/1.9.7 mapboxStyleConfig and the Earth avatar camera.
export const APP_MAP_STYLE = 'mapbox://styles/mapbox/standard';
export const APP_CAMERA = { pitch: 65, zoom: 19 };
export const LIGHT_PRESETS = ['day', 'dawn', 'dusk', 'night'];
export function basemapConfig(lightPreset) {
  return {
    lightPreset,
    show3dObjects: true, show3dBuildings: true, show3dTrees: true,
    show3dLandmarks: true, show3dFacades: true, showHdRoads: true,
  };
}
export function areaBounds(area) {
  if (!area || !validCenter(area.latitude, area.longitude) || !(Number(area.radius_m) > 0)) return null;
  const points = circleGeoJSON(area.latitude, area.longitude, area.radius_m).geometry.coordinates[0];
  return [
    [Math.min(...points.map(point => point[0])), Math.max(-85.05112878, Math.min(...points.map(point => point[1])))],
    [Math.max(...points.map(point => point[0])), Math.min(85.05112878, Math.max(...points.map(point => point[1])))],
  ];
}
